/* Vigía CO — interactividad de la landing */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cop = function (n) { return '$' + Math.round(n).toLocaleString('es-CO'); };

  /* ---------- Reveal al hacer scroll ---------- */
  function initReveal() {
    var els = $$('.vc-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Contador regresivo (persistido por sesión) ---------- */
  function initCountdown() {
    $$('[data-vc-cd]').forEach(function (el) {
      var mins = parseInt(el.getAttribute('data-vc-cd'), 10) || 20;
      var key = 'vc_cd_end', end = 0;
      try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) {}
      if (!end || end < Date.now()) {
        end = Date.now() + mins * 60000;
        try { sessionStorage.setItem(key, end); } catch (e) {}
      }
      var tick = function () {
        var left = Math.max(0, end - Date.now());
        var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
        el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        if (left <= 0) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
      };
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- Contadores animados ---------- */
  function initCounters() {
    var els = $$('[data-vc-count]');
    if (!els.length) return;
    var run = function (el) {
      var to = parseFloat(el.getAttribute('data-vc-count')), dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      var t0 = null, dur = 1400;
      var step = function (t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur), v = to * (1 - Math.pow(1 - p, 3));
        el.textContent = dec ? v.toFixed(dec).replace('.', ',') : Math.round(v).toLocaleString('es-CO');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { run(x.target); io.unobserve(x.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Galería del hero ---------- */
  function initGallery() {
    var main = $('[data-vc-main]');
    if (!main) return;
    $$('[data-vc-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-vc-thumb]').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        main.style.opacity = '.2';
        setTimeout(function () { main.src = b.getAttribute('data-src'); main.style.opacity = '1'; }, 160);
      });
    });
  }

  /* ---------- Selector de packs ---------- */
  function initPacks() {
    var packs = $$('[data-vc-pack]');
    if (!packs.length) return;
    var idInput = $('[data-vc-id]'), qtyInput = $('[data-vc-qty]');
    var apply = function (p) {
      packs.forEach(function (x) { x.classList.toggle('on', x === p); });
      var radio = $('input', p); if (radio) radio.checked = true;
      var price = parseFloat(p.getAttribute('data-price')), cmp = parseFloat(p.getAttribute('data-compare')) || 0;
      var units = parseInt(p.getAttribute('data-units'), 10) || 1;
      $$('[data-vc-sel-price]').forEach(function (e) { e.textContent = cop(price); });
      $$('[data-vc-sel-label]').forEach(function (e) { e.textContent = units + (units === 1 ? ' detector' : ' detectores') + ' · Envío gratis'; });
      var save = $('[data-vc-save]');
      if (save) save.textContent = cmp > price ? 'Ahorras ' + cop(cmp - price) + ' (' + Math.round((1 - price / cmp) * 100) + '% menos)' : '';
      var vid = p.getAttribute('data-variant');
      if (idInput && vid) idInput.value = vid;
      if (qtyInput) qtyInput.value = p.getAttribute('data-variant') && p.getAttribute('data-usa-var') === '1' ? 1 : units;
      try { var u = new URL(location.href); if (vid) { u.searchParams.set('variant', vid); history.replaceState(null, '', u); } } catch (e) {}
      window.vcSelectedUnits = units;
    };
    packs.forEach(function (p) {
      p.addEventListener('click', function () { apply(p); });
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); apply(p); } });
    });
    var def = $('[data-vc-pack].on') || packs[0];
    apply(def);
    window.vcSelectPack = function (units) {
      if (packs.length === 1) {
        var one = packs[0], pr = parseFloat(one.getAttribute('data-price'));
        if (qtyInput) qtyInput.value = units;
        $$('[data-vc-sel-price]').forEach(function (e) { e.textContent = cop(pr * units); });
        $$('[data-vc-sel-label]').forEach(function (e) { e.textContent = units + (units === 1 ? ' detector' : ' detectores') + ' · Envío gratis'; });
        return;
      }
      var t = packs.filter(function (p) { return parseInt(p.getAttribute('data-units'), 10) === units; })[0] || packs[packs.length - 1];
      apply(t);
    };
  }

  /* ---------- Sticky CTA (móvil) ---------- */
  function initSticky() {
    var st = $('.vc-sticky'), hero = $('.vc-hero');
    if (!st || !hero) return;
    var chk = function () {
      var r = hero.getBoundingClientRect();
      st.classList.toggle('show', r.bottom < 120);
    };
    window.addEventListener('scroll', chk, { passive: true }); chk();
  }

  /* ---------- Barra de stock animada ---------- */
  function initStock() {
    $$('[data-vc-stockbar]').forEach(function (b) {
      var w = b.getAttribute('data-vc-stockbar');
      setTimeout(function () { b.style.width = w + '%'; }, 500);
    });
  }

  /* ---------- Simulador de ppm ---------- */
  function initPPM() {
    var root = $('[data-vc-ppm]');
    if (!root) return;
    var range = $('[data-ppm-range]', root), num = $('[data-ppm-num]', root), arc = $('[data-ppm-arc]', root);
    var lvl = $('[data-ppm-lvl]', root), t = $('[data-ppm-t]', root), d = $('[data-ppm-d]', root);
    var rowA = $('[data-ppm-a]', root), rowB = $('[data-ppm-b]', root), btn = $('[data-ppm-sim]', root);
    var sub = $('[data-ppm-sub]', root);
    var LEVELS = [
      { max: 9, c: '#15a06f', t: 'Aire normal', d: 'Es el nivel habitual en una casa sin fuentes de combustión descontroladas. Tu detector marca cero o casi cero.' },
      { max: 29, c: '#9bcf3a', t: 'Algo está generando CO', d: 'La mayoría de las personas no siente nada, pero este número ya indica una combustión incompleta en algún aparato. Es el momento ideal para revisarlo.' },
      { max: 69, c: '#f5a524', t: 'Exposición que se acumula', d: 'Con varias horas de exposición puede aparecer dolor de cabeza y cansancio. Niños, adultos mayores, embarazadas y personas con problemas del corazón son más sensibles.' },
      { max: 149, c: '#ef7b2a', t: 'Dolor de cabeza, mareo y náuseas', d: 'Los síntomas aparecen en pocas horas y se pueden confundir con una gripa o con cansancio. Aquí un detector común apenas empieza a poder sonar.' },
      { max: 299, c: '#e5484d', t: 'Peligro serio', d: 'Mareo fuerte, confusión y riesgo de desmayo. Moverse y tomar decisiones se vuelve difícil. Hay que salir de la casa y pedir ayuda.' },
      { max: 9999, c: '#b3202a', t: 'Riesgo de muerte', d: 'Niveles que pueden ser mortales en cuestión de horas. Salir de inmediato, no volver a entrar y llamar a emergencias (123 en Colombia).' }
    ];
    var MAXP = 400, ALARM_STD = 70, ALARM_VC = parseInt(root.getAttribute('data-alarm') || '30', 10);
    var LEN = 251.3; /* longitud del arco SVG */
    var set = function (v) {
      v = Math.max(0, Math.min(MAXP, v));
      num.textContent = Math.round(v);
      var L = LEVELS.filter(function (x) { return v <= x.max; })[0];
      arc.style.strokeDasharray = (LEN * v / MAXP) + ' ' + LEN;
      arc.style.stroke = L.c;
      lvl.style.borderLeftColor = L.c; t.textContent = L.t; d.textContent = L.d;
      var onB = v >= ALARM_VC, onA = v >= ALARM_STD;
      rowB.classList.toggle('on', onB); rowA.classList.toggle('on', onA);
      $('small', rowB).textContent = onB ? 'Ya está alertando a todos los celulares y suena la alarma' : 'En silencio: el aire todavía está por debajo de ' + ALARM_VC + ' ppm';
      $('small', rowA).textContent = onA ? 'Recién puede empezar a sonar (la norma le da de 1 a 4 horas a 70 ppm)' : 'En silencio: la norma no le exige sonar hasta 70 ppm';
      if (sub) sub.textContent = v < ALARM_VC ? 'Mueve la barra para ver qué pasa' : '';
    };
    range.addEventListener('input', function () { set(parseFloat(range.value)); });
    var timer = null;
    btn.addEventListener('click', function () {
      if (timer) { clearInterval(timer); timer = null; btn.textContent = 'Simular una fuga lenta'; return; }
      var v = 0; range.value = 0; set(0); btn.textContent = 'Detener simulación';
      timer = setInterval(function () {
        v += 1.6; range.value = v; set(v);
        if (v >= MAXP) { clearInterval(timer); timer = null; btn.textContent = 'Simular una fuga lenta'; }
      }, 55);
    });
    set(0);
  }

  /* ---------- Hotspots de fuentes de CO ---------- */
  function initSources() {
    var root = $('[data-vc-src]');
    if (!root) return;
    var hots = $$('[data-hot]', root), items = $$('[data-item]', root);
    var go = function (i) {
      hots.forEach(function (h) { h.classList.toggle('on', h.getAttribute('data-hot') === i); });
      items.forEach(function (h) { h.classList.toggle('on', h.getAttribute('data-item') === i); });
    };
    hots.forEach(function (h) { h.addEventListener('click', function () { go(h.getAttribute('data-hot')); }); });
    items.forEach(function (h) { h.addEventListener('click', function () { go(h.getAttribute('data-item')); }); });
    go('0');
  }

  /* ---------- Calculadora de detectores ---------- */
  function initCalc() {
    var root = $('[data-vc-calc]');
    if (!root) return;
    var state = { pisos: 1, cuartos: 3, aparatos: 2 };
    var big = $('[data-calc-n]', root), why = $('[data-calc-why]', root), list = $('[data-calc-list]', root);
    var calc = function () {
      var n = Math.max(state.pisos, Math.ceil(state.cuartos / 2)) + (state.aparatos >= 3 ? 1 : 0);
      n = Math.max(1, Math.min(n, 6));
      big.textContent = n;
      why.textContent = n === 1 ? 'detector: un buen comienzo cerca de las habitaciones.' : 'detectores para cubrir habitaciones y zonas con aparatos de gas.';
      var items = [];
      items.push('Uno cerca de las habitaciones donde se duerme');
      if (state.aparatos >= 1) items.push('Uno en la zona de cocina o ropas (a unos 3 m del aparato)');
      if (state.pisos >= 2) items.push('Uno por cada piso, incluido el que tiene calentador');
      if (state.cuartos >= 4) items.push('Uno extra en el pasillo de las habitaciones');
      list.innerHTML = items.slice(0, 4).map(function (x) { return '<li>' + x + '</li>'; }).join('');
      root.setAttribute('data-n', n);
    };
    $$('[data-q]', root).forEach(function (grp) {
      var k = grp.getAttribute('data-q');
      $$('.vc-chip', grp).forEach(function (c) {
        c.addEventListener('click', function () {
          $$('.vc-chip', grp).forEach(function (x) { x.classList.remove('on'); });
          c.classList.add('on'); state[k] = parseInt(c.getAttribute('data-v'), 10); calc();
        });
      });
    });
    var go = $('[data-calc-go]', root);
    if (go) go.addEventListener('click', function () {
      var n = parseInt(root.getAttribute('data-n'), 10) || 2;
      var units = n <= 1 ? 1 : (n === 2 ? 2 : 3);
      if (window.vcSelectPack) window.vcSelectPack(units);
      var h = $('.vc-hero'); if (h) h.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    calc();
  }

  /* ---------- Teléfono animado ---------- */
  function initPhone() {
    var root = $('[data-vc-phone]');
    if (!root) return;
    var n1 = $('[data-n1]', root), n2 = $('[data-n2]', root), val = $('[data-pv]', root), room = $('[data-room]', root);
    var started = false;
    var play = function () {
      var seq = function () {
        n1.classList.remove('show'); n2.classList.remove('show'); room.classList.remove('alert'); val.textContent = '2';
        setTimeout(function () { val.textContent = '18'; }, 500);
        setTimeout(function () { n1.classList.add('show'); val.textContent = '24'; }, 1400);
        setTimeout(function () { n1.classList.remove('show'); val.textContent = '31'; room.classList.add('alert'); n2.classList.add('show'); }, 4200);
        setTimeout(function () { n2.classList.remove('show'); }, 7600);
      };
      seq(); setInterval(seq, 9800);
    };
    if (!('IntersectionObserver' in window)) { play(); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting && !started) { started = true; play(); io.disconnect(); } });
    }, { threshold: 0.4 });
    io.observe(root);
  }

  /* ---------- Comparativa con interruptor ---------- */
  function initCompare() {
    var root = $('[data-vc-cmp]');
    if (!root) return;
    $$('.vc-tog button', root).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.vc-tog button', root).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        root.setAttribute('data-mode', b.getAttribute('data-m'));
        $$('.row[data-grp]', root).forEach(function (r) {
          var g = r.getAttribute('data-grp'), m = b.getAttribute('data-m');
          r.hidden = !(m === 'all' || g === m);
        });
      });
    });
  }

  /* ---------- Reseñas: filtro + flechas ---------- */
  function initReviews() {
    var root = $('[data-vc-rev]');
    if (!root) return;
    var track = $('.vc-rv', root);
    $$('[data-f]', root).forEach(function (c) {
      c.addEventListener('click', function () {
        $$('[data-f]', root).forEach(function (x) { x.classList.remove('on'); });
        c.classList.add('on');
        var f = c.getAttribute('data-f');
        $$('.vc-rcard', root).forEach(function (r) { r.hidden = !(f === 'todas' || r.getAttribute('data-tag') === f); });
        track.scrollTo({ left: 0, behavior: 'smooth' });
      });
    });
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -340, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: 340, behavior: 'smooth' }); });
  }

  function initMini() {
    var root = $('[data-vc-mini]');
    if (!root) return;
    var cards = $$('.vc-mini-c', root), dots = $$('.vc-mini-dots button', root), i = 0, t = null;
    var show = function (n) {
      i = (n + cards.length) % cards.length;
      cards.forEach(function (c, k) { c.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    };
    var auto = function () { clearInterval(t); t = setInterval(function () { show(i + 1); }, 5500); };
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); auto(); }); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); auto(); } x0 = null;
    });
    auto();
  }

  function initFmt() {
    $$('[data-vc-fmt]').forEach(function (e) { e.textContent = cop(parseFloat(e.getAttribute('data-vc-fmt')) || 0); });
  }

  function boot() {
    [initFmt, initReveal, initCountdown, initCounters, initGallery, initPacks, initSticky, initStock,
     initMini, initPPM, initSources, initCalc, initPhone, initCompare, initReviews].forEach(function (f) {
      try { f(); } catch (e) { if (window.console) console.warn('vc init', f.name, e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
